// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner-placeholder[data-v-0df41cf2]{height:3.875rem}@media (min-width:1024px){.banner-placeholder[data-v-0df41cf2]{height:5.75rem}}@media (-ms-high-contrast:active),(-ms-high-contrast:none){.ie-hidden[data-v-0df41cf2]{display:none!important}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
